import React from 'react';
import { cn } from '../../lib/utils';

interface SearchFilterSkeletonProps {
  className?: string;
}

export function SearchFilterSkeleton({ className = '' }: SearchFilterSkeletonProps) {
  return (
    <div className={cn('flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8 lg:gap-16', className)}>
      {/* Search Section skeleton */}
      <div className="flex-1 lg:max-w-md">
        <div className="w-48 h-4 skeleton-item rounded mb-4 skeleton-stagger-1"></div>
        <div className="w-full h-12 skeleton-item rounded skeleton-stagger-2"></div>
      </div>

      {/* Filter Section skeleton */}
      <div className="flex-1 lg:max-w-md">
        <div className="w-40 h-4 skeleton-item rounded mb-4 skeleton-stagger-3"></div>
        <div className="flex gap-4">
          <div className="flex-1">
            <div className="w-full h-12 skeleton-item rounded skeleton-stagger-4"></div>
          </div>
          <div className="flex-1">
            <div className="w-full h-12 skeleton-item rounded skeleton-stagger-5"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
